// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-maintenance',
//   templateUrl: './maintenance.component.html',
//   styleUrls: ['./maintenance.component.scss']
// })
// export class MaintenanceComponent implements OnInit {

//   year: number = new Date().getFullYear();

//   constructor() {}

//   ngOnInit(): void {
//     // No login check required here
//   }
// }


import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

  year: number = new Date().getFullYear();
  countdown: number = 5;
  redirectUrl: string = "https://dev-ubi-store.kellton.net/product?attribute=&priceFrom=&priceTo=&brand=&offset=0&index=0&categorySlug=&categoryId=&sortby=&order=&popular=&deal=&flashDeal=&subCategorySlug=&keyword=&name=&discountDeal=";

  constructor() {}

  ngOnInit(): void {
    const interval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        clearInterval(interval);
        window.location.href = this.redirectUrl;
      }
    }, 1000);
  }
}
